import { Section } from "../../../types";
import { useEffect, useState } from "react";
import { savePage } from "../../util/api";

const StatementUpload = ({
  data,
  pageId,
}: {
  data: Section[];
  pageId: number;
}) => {
  const [editableData, setEditableData] = useState<Section[]>([]);
  const [password, setPassword] = useState("");

  useEffect(() => {
    setEditableData(data);
  }, [data]);

  const updateText = (
    sectionPosition: number,
    textPosition: number,
    content: string
  ) => {
    setEditableData((prev) => {
      if (prev.length === 0) {
        return [
          {
            id: -1,
            position: 0,
            texts: [
              {
                id: -2,
                position: 0,
                content: content,
              },
            ],
            pictures: [],
          },
        ];
      }

      const newSections = [...prev];
      newSections[sectionPosition].texts[textPosition].content = content;
      return newSections;
    });
  };

  const handleSave = () => {
    savePage({
      page: {
        title: "Statement",
        id: pageId,
        sections: editableData,
      },
      password,
    })
      .then((statusText) => {
        if (statusText === 200) {
          window.location.reload();
        }
      })
      .catch((e) => console.error(e));
  };

  return (
    <div>
      <h1>Statement</h1>
      <textarea
        value={editableData[0]?.texts[0]?.content}
        onChange={(e) => updateText(0, 0, e.target.value)}
      />
      <button onClick={handleSave} disabled={password === ""}>
        Save
      </button>
      Password:
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </div>
  );
};

export default StatementUpload;
